import { post } from 'redux/listings/actions';
import { createResourceActions } from 'utils/actionsGenerator';

import {
    EDIT_IN_LISTING,
    FETCH_RANKINGS,
    FETCH_RANKINGS_FAIL,
    FETCH_RANKINGS_SUCCESS,
    types,
} from './reducer';

export const { patch, put } = createResourceActions({
    name: 'listing',
    types,
    url: '/listings',
});

export const fetchRankings = (listingId, params) => ({
    listingId,
    payload: {
        request: {
            method: 'get',
            params: {
                days: 30,
                ...params,
            },
            url: `/listings/${listingId}/rankings`,
        },
    },
    types: [FETCH_RANKINGS, FETCH_RANKINGS_SUCCESS, FETCH_RANKINGS_FAIL]
});

export const saveListing = (data) => (dispatch) => {
    return data.get('id')
        ? dispatch(patch(data.get('id'), data))
        : dispatch(post(data));
};

export const editInListing = (path) => (value) => ({
    path,
    type: EDIT_IN_LISTING,
    value
});



// WEBPACK FOOTER //
// ./src/redux/listing/actions.js